import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-bracelet"
    exact
    path="/business/products/ar-bracelet"
    component={AsyncPage}
  />,
];
